// This javascript is used for the add/remove to moodboard functionality of the 'new' content block styles.

const V2_MOODBOARD_PRODUCT_COUNTERS = [
  document.getElementById("moodboard_product_count"),
  document.getElementById("moodboard_product_count_mobile"),
];
const V2_MOODBOARD_MODIFY_PRODUCTS_FUNCTION = function (
  event,
  productID,
  method,
  classToHide,
  reload
) {
  event.preventDefault();

  fetch(`/mijn-favorieten/${productID}`, { method: method })
    .then((response) => response.json())
    .then((response) =>
      Array.from(V2_MOODBOARD_PRODUCT_COUNTERS).forEach(
        (element) => (element.innerText = response.moodboard_products || 0)
      )
    )
    .then(function () {
      if (reload) {
        location.reload();
        return;
      }

      document
        .querySelectorAll(`[data-product-id=\"${productID}\"]`)
        .forEach(function (element) {
          const classToShow =
            classToHide === "moodboard-remove-product"
              ? "moodboard-add-product"
              : "moodboard-remove-product";

          if (element.classList.contains(classToHide)) {
            element.classList.add("hidden");
          }
          if (element.classList.contains(classToShow)) {
            element.classList.remove("hidden");
          }
          if (classToShow === "moodboard-remove-product" && element.classList.contains("moodboard-goto-favourites")) {
            element.classList.remove("hidden");
          }
        });
    });
};

const V2_MOODBOARD_ADD_PRODUCT_BUTTONS = document.getElementsByClassName(
  "moodboard-add-product"
);
const V2_MOODBOARD_REMOVE_PRODUCT_BUTTONS = document.getElementsByClassName(
  "moodboard-remove-product"
);
const V2_MOODBOARD_UPDATE_PRODUCT_INPUTS = document.getElementsByClassName(
  "moodboard-update-product"
);

Array.from(V2_MOODBOARD_ADD_PRODUCT_BUTTONS).forEach((element) =>
  element.addEventListener("click", function (event) {
    const productID = this.getAttribute("data-product-id");
    const reload = this.getAttribute("data-reload") === "true";
    V2_MOODBOARD_MODIFY_PRODUCTS_FUNCTION(
      event,
      productID,
      "POST",
      "moodboard-add-product",
      reload
    );
  })
);

Array.from(V2_MOODBOARD_REMOVE_PRODUCT_BUTTONS).forEach((element) =>
  element.addEventListener("click", function (event) {
    const productID = this.getAttribute("data-product-id");
    const reload = this.getAttribute("data-reload") === "true";
    V2_MOODBOARD_MODIFY_PRODUCTS_FUNCTION(
      event,
      productID,
      "DELETE",
      "moodboard-remove-product",
      reload
    );
  })
);

Array.from(V2_MOODBOARD_UPDATE_PRODUCT_INPUTS).forEach((element) =>
  element.addEventListener("input", function (event) {
    const productID = this.getAttribute("data-product-id");
    fetch(`/mijn-favorieten/${productID}`, {
      method: "PUT",
      body: JSON.stringify({ quantity: element.value }),
    });
  })
);

const MOODBOARD_MODIFY_SERVICES_FUNCTION = function (
    event,
    serviceID,
    method,
    classToHide,
    reload,
    redirectTo = null
) {
    event.preventDefault();

    fetch(`/mijn-favorieten/dienst/${serviceID}`, { method: method })
        .then((response) => response.json())
        .then((response) =>
            Array.from(V2_MOODBOARD_PRODUCT_COUNTERS).forEach(
                (element) => (element.innerText = response.moodboard_products || 0)
            )
        )
        .then(function () {
            if (reload) {
                location.reload();
                return;
            } else if (redirectTo) {
                window.location.href = redirectTo;
                return;
            }

            document
                .querySelectorAll(`[data-service-id=\"${serviceID}\"]`)
                .forEach(function (element) {
                    const classToShow =
                        classToHide === "moodboard_remove_service"
                            ? "moodboard_add_service"
                            : "moodboard_remove_service";

                    if (element.classList.contains(classToHide)) {
                        element.classList.add("hidden");
                    }
                    if (element.classList.contains(classToShow)) {
                        element.classList.remove("hidden");
                    }
                });

            document.querySelectorAll(`.remove-after-remove[data-service-id="${serviceID}\"]`)
                .forEach(function (element) {
                    element.remove();
                })
        });
};

const MOODBOARD_ADD_SERVICE_BUTTONS = document.getElementsByClassName(
    "moodboard_add_service"
);
const MOODBOARD_ADD_SERVICE_LINK_BUTTONS = document.querySelectorAll('a.moodboard_add_service_wrapper');
const MOODBOARD_ADD_ALL_SERVICES_BUTTON = document.getElementsByClassName(
    "moodboard_add_all_services"
);
const MOODBOARD_ALL_SERVICES_ADDED_BUTTON = document.getElementsByClassName(
    "moodboard_all_services_added"
);
const MOODBOARD_REMOVE_SERVICE_BUTTONS = document.getElementsByClassName(
    "moodboard_remove_service"
);
const MOODBOARD_UPDATE_SERVICE_INPUTS = document.getElementsByClassName(
    "moodboard_update_service"
);

Array.from(MOODBOARD_ADD_SERVICE_LINK_BUTTONS).forEach((element) =>
    element.addEventListener("click", function (event) {
        const serviceID = this.getAttribute("data-service-id") || window.location.pathname.substring(1);
        let reload = true;
        let redirectTo = null;
        if (this.getAttribute("data-service-id")) {
            reload = this.getAttribute("data-reload") === "true";
        } else {
            reload = false;
            redirectTo = this.getAttribute("href");
        }
        MOODBOARD_MODIFY_SERVICES_FUNCTION(
            event,
            serviceID,
            "POST",
            "moodboard_add_service",
            reload,
            redirectTo
        );
    })
);
Array.from(MOODBOARD_ADD_SERVICE_BUTTONS).forEach((element) =>
    element.addEventListener("click", function (event) {
        const serviceID = this.getAttribute("data-service-id") || window.location.pathname;
        const reload = this.getAttribute("data-reload") === "true";
        MOODBOARD_MODIFY_SERVICES_FUNCTION(
            event,
            serviceID,
            "POST",
            "moodboard_add_service",
            reload
        );
    })
);

Array.from(MOODBOARD_ADD_ALL_SERVICES_BUTTON).forEach((element) =>
    element.addEventListener("click", function (event) {
        Array.from(MOODBOARD_ADD_SERVICE_BUTTONS).forEach((element) => element.click());
        element.classList.add('hidden');
        Array.from(MOODBOARD_ALL_SERVICES_ADDED_BUTTON).forEach((element) => element.classList.remove('hidden'));
    })
);

Array.from(MOODBOARD_REMOVE_SERVICE_BUTTONS).forEach((element) =>
    element.addEventListener("click", function (event) {
        const serviceID = this.getAttribute("data-service-id");
        const reload = this.getAttribute("data-reload") === "true";
        MOODBOARD_MODIFY_SERVICES_FUNCTION(
            event,
            serviceID,
            "DELETE",
            "moodboard_remove_service",
            reload
        );
    })
);

Array.from(MOODBOARD_UPDATE_SERVICE_INPUTS).forEach((element) =>
    element.addEventListener("input", function (event) {
        const serviceID = this.getAttribute("data-service-id");
        fetch(`/mijn-favorieten/${serviceID}`, {
            method: "PUT",
            body: JSON.stringify({ quantity: element.value }),
        });
    })
);